<template>
  <div id="news">
    <div class="container pb100">
      <p class="text-center font20 mt50">NEWS</p>
      <p class="text-center font16">BLACK NOVA PARTNER NETWORK</p>
      <p class="text-center mt30">For all media inquiries contact us at press@blacknova.co</p>
      <div class="mt50 row">
        <div class="col-md-4 text-center font16 lh2">FILTER BY:</div>
        <div class="col-md-4">
          <select v-model="topic" class="form-control" id="topic">
            <option value="all">All Topics</option>
          </select>
          <span class="sel"></span>
        </div>
      </div>
      <div class="row mt30">
        <div class="col-md-12">
          <div class="input-group search">
            <input @input="get_posts" v-model="search" type="text" class="form-control text-center" placeholder="Search for a Project" />
          </div>
        </div>
      </div>
      <div class="row mt30">
        <a class="col-sm-6 news" @click="open_post(post)" v-for="(post, index) in displayedPosts" :key="index">
          <div class="img" :style="{backgroundImage:'url(' + $store.state.serverURL + '/' + post.file_name + ')'}"></div>
          <div class="border p20 news-content">
            <div class="news-header">
              <p class="title">{{ post.title }}</p>
              <p class="cat gray">{{ post.tag }}</p>
            </div>
            <div class="text-box" v-html="post.content"></div>
            <p class="day text-right">{{ new Date(post.created_at) | dateFormat('DD.MM.YYYY') }}</p>
          </div>
        </a>
      </div>
      <nav aria-label="Page navigation" class="text-center">
        <ul class="pagination">
          <li v-if="page != 1" @click="page--">
            <a href="#" aria-label="Previous" >
              <span aria-hidden="true" class="iconfont3 icon-back font11"></span>
            </a>
          </li>
          <li v-for="(pageNumber, index) in pages.slice(page-1, page+5)" @click="page = pageNumber" :key="index">
            <a :class="{active: pageNumber == page}" href="#" >{{ pageNumber }}</a>
          </li>
          <li @click="page++" v-if="page < pages.length">
            <a href="#" aria-label="Next" >
              <span aria-hidden="true" class="iconfont3 icon-next font11"></span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "../assets/css/news.css";
export default {
  name: "news",
  data() {
    return {
      posts: [],
      topic: "all",
      page: 1,
      perPage: 4,
      pages: [],
      search: ''
    };
  },
  mounted() {
    this.get_tags();
    this.get_posts();
  },
  computed: {
    displayedPosts() {
      return this.paginate(this.posts);
    }
  },
  watch: {
    topic() {
      this.get_posts();
    },
    posts() {
      this.set_pages();
    }
  },
  methods: {
    open_post(post) {
      this.$router.push({name: 'post', params: { post: post }});
    },
    get_tags() {
      axios
        .get("/news/tags")
        .then(response => {
          var topic = document.getElementById("topic");
          for (var tag of response.data) {
            let option = document.createElement("option");
            option.innerHTML = tag;
            topic.append(option);
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    get_posts() {
      this.page = 1;
      this.pages = [];
      let path = "/news/search/" + this.topic;
      if (this.search != '') {
        path =  path + '/' + this.search;
      }
      axios
        .get(path)
        .then(response => {
          this.posts = response.data;
        })
        .catch(function(error) {
          alert(error);
        });
    },
    set_pages() {
      this.pages = [];
      let numberOfPages = Math.ceil(this.posts.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(posts) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return posts.slice(from, to);
    }
  }
};
</script>

<style>
</style>
